import { ReturnComponent } from '@/utils/reactTypes';

import { GlobalDesktopNavigationDrawer } from './components/GlobalDesktopNavigationDrawer';
import { GlobalMobileNavigationDrawer } from './components/GlobalMobileNavigationDrawer';
import { useIsGlobalNavMobile } from './lib/hooks';

export const GlobalNavigationDrawer = (): ReturnComponent =>
    useIsGlobalNavMobile() ? <GlobalMobileNavigationDrawer /> : <GlobalDesktopNavigationDrawer />;
